/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Regenerated by `npm run cms:sync` from /api/cms/public/service-areas.
 *
 * The four service-area cards on /about render in `sort_order`
 * ASC, so the seeded 10/20/30/40 spacing keeps insertion-friendly.
 *
 * The flat `title` / `description` mirror the zh-Hant copy. A
 * locale-aware consumer reads `locales[locale]` instead — see
 * src/content/cms/serviceAreaLocale.ts.
 */

export interface CmsServiceAreaLocaleCopy {
  title: string
  description: string
}

export interface CmsServiceAreaIndexEntry {
  id: number
  slug: string
  icon: string
  accent_gradient: string
  title: string
  description: string
  sort_order: number
  published_at: number | null
  /** Every locale's copy, resolved at build time. */
  locales: {
    'zh-Hant': CmsServiceAreaLocaleCopy
    'zh-Hans': CmsServiceAreaLocaleCopy
    en: CmsServiceAreaLocaleCopy
  }
}

export const cmsServiceAreas: CmsServiceAreaIndexEntry[] = [
  {
    "id": 1,
    "slug": "direct-support",
    "icon": "lucide:hand-heart",
    "accent_gradient": "from-yada-gold to-yada-olive",
    "title": "青年直接支援",
    "description": "為青年提供學業指導、生涯探索及人生規劃的直接服務與活動，協助他們在升學與就業路上作出明智選擇。",
    "sort_order": 10,
    "published_at": 1791517272239,
    "locales": {
      "zh-Hant": {
        "title": "青年直接支援",
        "description": "為青年提供學業指導、生涯探索及人生規劃的直接服務與活動，協助他們在升學與就業路上作出明智選擇。"
      },
      "zh-Hans": {
        "title": "青年直接支援",
        "description": "为青年提供学业指导、生涯探索及人生规划的直接服务与活动，协助他们在升学与就业路上作出明智选择。"
      },
      "en": {
        "title": "Direct Youth Support",
        "description": "Providing direct services and activities — academic guidance, career exploration, and life planning — to help young people make informed choices on their path to further study and work."
      }
    }
  },
  {
    "id": 2,
    "slug": "tech-solutions",
    "icon": "lucide:workflow",
    "accent_gradient": "from-yada-green to-yada-green-dark",
    "title": "科技驅動方案",
    "description": "設計、建構並提供技術驅動的解決方案、系統及框架，賦能合作機構、學校、教育工作者及社會服務單位，提升青年發展及生涯規劃服務的效能。",
    "sort_order": 20,
    "published_at": 1791517272239,
    "locales": {
      "zh-Hant": {
        "title": "科技驅動方案",
        "description": "設計、建構並提供技術驅動的解決方案、系統及框架，賦能合作機構、學校、教育工作者及社會服務單位，提升青年發展及生涯規劃服務的效能。"
      },
      "zh-Hans": {
        "title": "科技驱动方案",
        "description": "设计、构建并提供技术驱动的解决方案、系统及框架，赋能合作机构、学校、教育工作者及社会服务单位，提升青年发展及生涯规划服务的效能。"
      },
      "en": {
        "title": "Tech-Driven Solutions",
        "description": "Designing, building, and offering technology-driven solutions, systems, and frameworks that empower partnering organisations, schools, educators, and social service units to enhance youth development and career planning services."
      }
    }
  },
  {
    "id": 3,
    "slug": "research",
    "icon": "lucide:flask-conical",
    "accent_gradient": "from-yada-olive to-yada-brown",
    "title": "學術研究與實證",
    "description": "進行、委託及發表與青年職業發展、教育路徑及生涯規劃方法相關的研究，以實證推動服務創新。",
    "sort_order": 30,
    "published_at": 1791517272239,
    "locales": {
      "zh-Hant": {
        "title": "學術研究與實證",
        "description": "進行、委託及發表與青年職業發展、教育路徑及生涯規劃方法相關的研究，以實證推動服務創新。"
      },
      "zh-Hans": {
        "title": "学术研究与实证",
        "description": "进行、委托及发表与青年职业发展、教育路径及生涯规划方法相关的研究，以实证推动服务创新。"
      },
      "en": {
        "title": "Research & Evidence",
        "description": "Conducting, commissioning, and publishing research on youth career development, education pathways, and career planning methods — driving service innovation with evidence."
      }
    }
  },
  {
    "id": 4,
    "slug": "advocacy",
    "icon": "lucide:megaphone",
    "accent_gradient": "from-yada-brown to-yada-coffee",
    "title": "倡議與協作",
    "description": "透過研討會、公眾宣傳及協作框架，倡導、推廣及強化社區、機構及政策層面的生涯規劃支援系統。",
    "sort_order": 40,
    "published_at": 1791517272239,
    "locales": {
      "zh-Hant": {
        "title": "倡議與協作",
        "description": "透過研討會、公眾宣傳及協作框架，倡導、推廣及強化社區、機構及政策層面的生涯規劃支援系統。"
      },
      "zh-Hans": {
        "title": "倡议与协作",
        "description": "透过研讨会、公众宣传及协作框架，倡导、推广及强化社区、机构及政策层面的生涯规划支援系统。"
      },
      "en": {
        "title": "Advocacy & Collaboration",
        "description": "Championing and strengthening career-planning support at the community, institutional, and policy levels through seminars, public engagement, and collaborative frameworks."
      }
    }
  }
]
